import React from 'react';
import './ProductGDPR.css';

const cards = [
  {
    title: 'Readiness assessments',
    icon: <svg width="40" height="40" fill="none" stroke="#0099d0" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M8 12h4l2 2"/><circle cx="12" cy="8" r="1"/></svg>
  },
  {
    title: 'Assessment Automation',
    icon: <svg width="40" height="40" fill="none" stroke="#0099d0" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/><circle cx="8" cy="14" r="2"/><path d="M12 14h4"/></svg>
  },
  {
    title: 'Data mapping & Inventory',
    icon: <svg width="40" height="40" fill="none" stroke="#0099d0" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>
  },
  {
    title: 'Website scanning & cookie compliance',
    icon: <svg width="40" height="40" fill="none" stroke="#0099d0" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M8 8h8v8H8z"/></svg>
  }
];

const ProductGDPR = () => (
  <section className="gdpr-section">
    <div className="gdpr-container">
      <div className="gdpr-cards">
        {cards.map((card, i) => (
          <div className="gdpr-card" key={i}>
            <div className="gdpr-card-icon">{card.icon}</div>
            <div className="gdpr-card-title">{card.title}</div>
          </div>
        ))}
        <div className="gdpr-dots">
          <span className="dot active"></span>
          <span className="dot"></span>
        </div>
      </div>
      <div className="gdpr-content">
        <h2 className="gdpr-title">Data Protection (GDPR)</h2>
        <p className="gdpr-desc">
          Easily manage risk, consent, access rights, and more with 8 powerful tools that keep your healthcare data safe and compliant.
        </p>
        <a href="#" className="gdpr-btn">Explore GDPR Tools <span className="arrow">↗</span></a>
      </div>
    </div>
  </section>
);

export default ProductGDPR; 